import React from 'react';
import '@atlaskit/css-reset';
import NewIssueSearchTransitionApp from '@atlassian/jira-admin-pages-new-issue-search-transition/src/ui/index.tsx';
import { MarkProductStart } from '@atlassian/jira-spa-performance-breakdown/src/utils/mark-product-start/index.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<>
		<MarkProductStart />
		<NewIssueSearchTransitionApp />
	</>
);
